//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;
    $('html, body').animate({ scrollTop: position }, speed, 'swing');

    $('.js-spNav').removeClass('is-show');

    return false;
  });
});

$(function () {
  $('.js-hd__menu').each(function (index, el) {
    const $menu = $(this);
    const $close = $('.js-spNav__close');
    const $nav = $('.js-spNav');

    $menu.on('click', function (event) {
      $nav.addClass('is-show');
    });

    $close.on('click', function (event) {
      $nav.removeClass('is-show');
    });
  });
});

$(function () {
  $('.l-homeSlider__slick').each(function (index, el) {
    const $slider = $(this);

    if ($slider.hasClass('-dots')) {
      $slider.slick({
        centerMode: true,
        variableWidth: true,
        dots: true,
      });
    } else {
      $slider.slick({
        centerMode: true,
        variableWidth: true,
      });
    }
  });
});

$(function () {
  $('.l-modalSlider__slick').each(function (index, el) {
    const $slider = $(this);
    let now = 0;

    if ($slider.hasClass('-dots')) {
      $slider.slick({
        dots: true,
      });
    } else {
      $slider.slick({});
    }

    $('.js-modalSlider').each(function (index, el) {
      var t = $(this);

      t.on('opening', function () {
        $slider.slick('setPosition');
      });

      t.on('opened', function () { });

      t.on('closing', function (e) { });

      t.on('closed', function (e) { });
    });

    $('a[data-remodal-num]').on('click', function (event) {
      now = $(this).attr('data-remodal-num') - 1;

      $slider.slick('slickGoTo', now, true);
    });
  });
});

$(function () {
  $('.js-modalMovie').each(function (index, el) {
    var t = $(this);

    t.on('opening', function () { });

    t.on('opened', function () {
      var p = t.find('.js-modalVideo').get(0);
      p.play();
    });

    t.on('closing', function (e) {
      var p = t.find('.js-modalVideo').get(0);
      p.stop();
    });

    t.on('closed', function (e) {
      var p = t.find('.js-modalVideo').get(0);
      p.stop();
    });
  });
});

$(function () {
  $('.p-gnav__parent').each(function (index, el) {
    const $p = $(this);
    const $c = $('.p-gnav__children');

    $p.hover(
      function () {
        $p.addClass('is-on');
        $c.stop().slideDown(300);
      },
      function () {
        $p.removeClass('is-on');
        $c.stop().slideUp(300);
      }
    );
  });
});

$(function () {
  $('.p-spNav__parent').each(function (index, el) {
    const $p = $(this);
    const $c = $p.find('.p-spNav__children');
    const $spp = $p.find('.js-spNavParent');

    if ($('.u-sp').css('display') != 'none') {
      $spp.on('click', function (event) {
        $c.stop().slideToggle(300);
        $p.toggleClass('is-on');
      });
    } else {
      $p.hover(
        function () {
          $c.stop().slideDown(300);
        },
        function () {
          $c.stop().slideUp(300);
        }
      );
    }
  });
});

$(function () {
  $('.js-modalVideoPlay').each(function (index, el) {
    const $play = $(this);
    const $video = $('.js-modalVideo').filter(
      '[data-modal-video-id="' + $play.attr('data-modal-video-target') + '"]'
    );

    if ($video) {
      $play.on('click', function (event) {
        $video.get(0).play();
      });
    }
  });
});

$(function () {
  const $kv = $('.home-kv');
  const $btn = $('.p-hd__fixBtn');

  if ($kv[0]) {
    $(window).on('scroll', function (event) {
      run();
    });

    run();

    function run() {
      if (
        $(window).scrollTop() + $(window).innerHeight() - 50 >
        $kv.innerHeight()
      ) {
        $btn.removeClass('is-hide');
      } else {
        $btn.addClass('is-hide');
      }
    }
  } else {
    $btn.removeClass('is-hide');
  }
});

var youtubeTag = document.createElement('script');
youtubeTag.src = 'https://www.youtube.com/iframe_api';
var youtubeFirstScriptTag = document.getElementsByTagName('script')[0];
youtubeFirstScriptTag.parentNode.insertBefore(
  youtubeTag,
  youtubeFirstScriptTag
);
var youtubePlayers = [];

function onYouTubeIframeAPIReady() {
  $('.moviePlayerAuto').each(function (index, el) {
    var t = $(this);
    t.attr('data-player-id', youtubePlayers.length);

    player = new YT.Player(t[0], {
      height: '360',
      width: '640',
      videoId: t.attr('data-video-id'),
      playerVars: {
        'modestbranding': 1,
        'autohide': 1,
        'controls': 0,
        'showinfo': 0,
        'rel': 0,
        'autoplay': 0,
        'playsinline': 1,
        'loop': 1,
        'playlist': t.attr('data-video-id'),
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange,
      },
    });
    youtubePlayers.push(player);

    function onPlayerStateChange(event) {
      var ytStatus = event.target.getPlayerState();

      // 再生終了したとき
      if (ytStatus == YT.PlayerState.ENDED) {
        event.target.seekTo(0, true); //動画の初めにシーク
        event.target.mute();
        event.target.playVideo();
      }
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.mute();
      //event.target.playVideo();
    }

    function playVideo() {
      player.mute();
      player.playVideo();
    }

    function stopVideo() {
      player.stopVideo();
    }
  });

  setTimeout(function () {
    $('.js-youtubePlayerModal').each(function (index, el) {
      var t = $(this);
      t.attr('data-player-id', youtubePlayers.length);

      var player = new YT.Player(t[0], {
        height: '360',
        width: '640',
        videoId: t.attr('data-video-id'),
        playerVars: {
          'modestbranding': 1,
          'autohide': 1,
          'controls': 1,
          'showinfo': 0,
          'rel': 0,
          'autoplay': 0,
          'playsinline': 1,
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange,
        },
      });
      youtubePlayers.push(player);

      function onPlayerStateChange(event) {
        /*var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.mute();
          player.playVideo();
        }*/
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        //event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });

    $('.remodalMovie').each(function (index, el) {
      var t = $(this);

      t.on('opening', function () { });

      t.on('opened', function () {
        var p =
          youtubePlayers[
          t.find('.js-youtubePlayerModal').attr('data-player-id')
          ];
        p.playVideo();
      });

      t.on('closing', function (e) {
        var p =
          youtubePlayers[
          t.find('.js-youtubePlayerModal').attr('data-player-id')
          ];
        p.stopVideo();
      });

      t.on('closed', function (e) {
        var p =
          youtubePlayers[
          t.find('.js-youtubePlayerModal').attr('data-player-id')
          ];
        p.stopVideo();
      });
    });
  }, 100);
}

/*以下guide-work*/
function tabactive(activeTab) {
  for (let tabNumber = 1; tabNumber <= 4; tabNumber++) {
    if (activeTab == 'work-tab' + tabNumber) {
      $('#' + activeTab).addClass('work-tab' + tabNumber + 'isActive');
      $('#work-contents' + tabNumber).css('display', 'block');
      continue;
    }
    $('#' + 'work-tab' + tabNumber).removeClass(
      'work-tab' + tabNumber + 'isActive'
    );
    $('#work-contents' + tabNumber).css('display', 'none');
  }
}

$(function () {
  $('.work-tabs').on('click', function () {
    tabactive(this.id);
  });
});

$(function () {
  $('.single-conBlockGallery__slick').each(function (index, el) {
    const $slider = $(this);

    if ($slider.hasClass('-dots')) {
      $slider.slick({
        centerMode: true,
        variableWidth: true,
        dots: true,
      });
    } else {
      $slider.slick({
        centerMode: true,
        variableWidth: true,
      });
    }

    // 左右の透過の2周目ががたつく対応
    $slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
      $slider.find(".slick-slide").each((index, el) => {
        const $this = $(el),
          slickindex = $this.attr("data-slick-index");
        if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
          // 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
          if (slickindex == "-1") {
            // 最後のスライドに対してクラスを付与
            $this.addClass("is-active-next");
          } else {
            // それ以外は削除
            $this.removeClass("is-active-next");
          }
        } else if (nextSlide == 0) {
          // 次のスライドが最初のスライドの場合
          if (slickindex == slick.slideCount) {
            // 最初のスライドに対してクラスを付与
            $this.addClass("is-active-next");
          } else {
            // それ以外は削除
            $this.removeClass("is-active-next");
          }
        } else {
          // それ以外は削除
          $this.removeClass("is-active-next");
        }
      });
    });


  });
});


$(function () {
  $('.single-workRelated__slick.-pc').each(function (index, el) {
    const $slider = $(this);

    if ($slider.hasClass('-dots')) {
      $slider.slick({
        dots: true,
      });
    } else {
      $slider.slick({
      });
    }
  });
});


$(function () {
  $('.single-workRelated__slick.-sp').each(function (index, el) {
    const $slider = $(this);

    if ($slider.hasClass('-dots')) {
      $slider.slick({
        centerMode: true,
        variableWidth: true,
        dots: true,
      });
    } else {
      $slider.slick({
        centerMode: true,
        variableWidth: true,
      });
    }
  });
});


$(function () {
  const $link = $('.guide-workSearch__moreLink');

  if ($link[0]) {
    const $con = $('.guide-workSearch__moreCon');

    $link.on('click', function () {
      $link.toggleClass('is-open');
      $con.stop().slideToggle(300);
    });
  }
});

$(function () {
  const $farmerLink = $('.js-farmerMore');

  if ($farmerLink[0]) {
    const $farmerCon = $('.js-farmer-con');

    $farmerLink.on('click', function () {
      $farmerLink.parent('.guide-workMore').removeClass('is-show');
      $farmerCon.removeClass('is-hide');
    });
  }
});

$(function () {
  const $farmerLink = $('.js-businessMore');

  if ($farmerLink[0]) {
    const $farmerCon = $('.js-business-con');

    $farmerLink.on('click', function () {
      $farmerLink.parent('.guide-workMore').removeClass('is-show');
      $farmerCon.removeClass('is-hide');
    });
  }
});

$(function () {
  const $root = $('.work-tabContents');

  $root.each(function (index, element) {
    const $con = $(this);

    const $recruitBtns = $con.find('.guide-workSearch__recruit input');

    const $typeBtns = $con.find('.guide-workSearch__btns.-type');
    const $areaBtns = $con.find('.guide-workSearch__btns.-area');
    const $lifestyleBtns = $con.find('.guide-workSearch__btns.-lifestyle');

    const $allBtn = $con.find('.guide-workSearch__btns button');
    const $typeBtn = $con.find('.guide-workSearch__btns.-type button');
    const $areaBtn = $con.find('.guide-workSearch__btns.-area button');
    const $lifestyleBtn = $con.find('.guide-workSearch__btns.-lifestyle button');

    const $posts = $con.find('.p-companyPosts__posts');
    const $post = $con.find('.p-companyPosts__post');

    if (!$typeBtns[0]) return true;

    init();

    function init() {
      let typeAll = [];

      $post.each(function (index, element) {
        const $t = $(this);

        let recruitData = $t.attr('data-recruit');
        let typeData = $t.attr('data-type').split(',');
        let areaData = $t.attr('data-area').split(',');
        let lifestyleData = $t.attr('data-lifestyle').split(',');
        let lifestyleCnt = 0;

        $typeBtn.each(function (index, element) {
          const $t2 = $(this);

          $.each(typeData, function (index, val) {
            if (val == $t2.attr('data-value')) {
              $t2.parent('li').removeClass('is-hide');
            }
          });

        });

        $areaBtn.each(function (index, element) {
          const $t2 = $(this);

          $.each(areaData, function (index, val) {
            if (val == $t2.attr('data-value')) {
              $t2.parent('li').removeClass('is-hide');
            }
          });

        });

        $lifestyleBtn.each(function (index, element) {
          const $t2 = $(this);

          $.each(lifestyleData, function (index, val) {
            if (val == $t2.attr('data-value')) {
              $t2.parent('li').removeClass('is-hide');
              lifestyleCnt++;
            }
          });

        });

        if (lifestyleCnt == 0) {
          $lifestyleBtns.hide().prev('h3').hide();
        }
      });
    }

    $recruitBtns.on('change', function () {
      search();
    });

    $allBtn.on('click', function () {
      const $t = $(this);

      $t.toggleClass('is-cr');

      if ($t.attr('data-value') == 'all') {
        $t.parent().parent().find('button').removeClass('is-cr');
      }

      search();
    });

    function search() {
      //すべてボタン
      if ($typeBtn.not('.-all').hasClass('is-cr')) {
        $typeBtn.filter('.-all').removeClass('is-cr');
      } else {
        $typeBtn.filter('.-all').addClass('is-cr');
      }

      if ($areaBtn.not('.-all').hasClass('is-cr')) {
        $areaBtn.filter('.-all').removeClass('is-cr');
      } else {
        $areaBtn.filter('.-all').addClass('is-cr');
      }

      if ($lifestyleBtn.not('.-all').hasClass('is-cr')) {
        $lifestyleBtn.filter('.-all').removeClass('is-cr');
      } else {
        $lifestyleBtn.filter('.-all').addClass('is-cr');
      }

      //絞り込み
      $post.removeClass('is-show').hide();
      var count = 0;
      $post.each(function (index, element) {
        const $t = $(this);
        let hitCnt = 4;
        let val = '';

        val = $recruitBtns.filter(':checked').val();
        if (val == 'all') {
          hitCnt--;
        } else if (val == $t.attr('data-recruit')) {
          hitCnt--;
        }

        $typeBtn.filter('.is-cr').each(function (index, element) {
          const $t2 = $(this);
          // val = $t2.attr('data-value');

          if ($t2.attr('data-value') == 'all') {
            hitCnt--;
            return false;
          } else {
            let typeData = $t.attr('data-type').split(',');

            $.each(typeData, function (index, val) {
              if (val == $t2.attr('data-value')) {
                hitCnt--;
                return false;
              }
            });
          }
        });

        $areaBtn.filter('.is-cr').each(function (index, element) {
          const $t2 = $(this);
          // val = $t2.attr('data-value');

          if ($t2.attr('data-value') == 'all') {
            hitCnt--;
            return false;
          } else {
            let areaData = $t.attr('data-area').split(',');

            $.each(areaData, function (index, val) {
              if (val == $t2.attr('data-value')) {
                hitCnt--;
                return false;
              }
            });
          }

          // if(val == 'all') {
          //   hitCnt --;
          //   return false;
          // } else if(val == $t.attr('data-area')) {
          //   hitCnt --;
          //   return false;
          // }
        });

        $lifestyleBtn.filter('.is-cr').each(function (index, element) {
          const $t2 = $(this);
          // val = $t2.attr('data-value');

          if ($t2.attr('data-value') == 'all') {
            hitCnt--;
            return false;
          } else {
            let lifestyleData = $t.attr('data-lifestyle').split(',');

            $.each(lifestyleData, function (index, val) {
              if (val == $t2.attr('data-value')) {
                hitCnt--;
                return false;
              }
            });
          }

          // if(val == 'all') {
          //   hitCnt --;
          //   return false;
          // } else if(val == $t.attr('data-lifestyle')) {
          //   hitCnt --;
          //   return false;
          // }
        });

        if (hitCnt <= 0) {
          count++;
          if ($posts.hasClass('is-hide')) {
            if (count < 7) {
              $t.fadeIn(400).addClass('is-show');
            } else {
              $t.removeAttr('style');
            }
          } else {
            $t.fadeIn(400).addClass('is-show');
          }
        }
      });
      if (count > 6) {
        if ($posts.hasClass('is-hide')) {
          $con.find('.guide-workMore').addClass('is-show');
        }
      } else {
        if ($posts.hasClass('is-hide')) {
          $con.find('.guide-workMore').removeClass('is-show');
        }
      }
    }
  });
});

/*以下guide-house-vacant*/
// function vacantTabactive(activeTab) {
//   for (let tabNumber = 1; tabNumber <= 5; tabNumber++) {
//     if (activeTab == 'vacant-tab' + tabNumber) {
//       $('#' + activeTab).addClass('vacant-tab' + tabNumber + 'isActive');
//       $('#vacant-contents' + tabNumber).css('display', 'block');
//       continue;
//     }
//     $('#' + 'vacant-tab' + tabNumber).removeClass(
//       'vacant-tab' + tabNumber + 'isActive'
//     );
//     $('#vacant-contents' + tabNumber).css('display', 'none');
//   }
// }

$(function () {
  $('.vacant-tabs').on('click', function () {
    vacantTabactive(this.id);
  });
});

// 物件をもっと見るボタン
$(function () {
  const $farmerLink = $('.js-vacantMore');

  if ($farmerLink[0]) {
    const $farmerCon = $('.js-vacant-con');

    $farmerLink.on('click', function () {
      $farmerLink.parent('.guide-vacantMore').removeClass('is-show');
      $farmerCon.removeClass('is-hide');
    });
  }
});

$(function () {
  const $root = $('.vacant-tabContents');

  $root.each(function (index, element) {
    const $con = $(this);

    const $statusBtns = $con.find('.guide-vacantSearch__status input');

    const $typeBtns = $con.find('.guide-vacantSearch__btns.-type');
    const $areaBtns = $con.find('.guide-vacantSearch__btns.-area');

    const $allBtn = $con.find('.guide-vacantSearch__btns button');
    const $typeBtn = $con.find('.guide-vacantSearch__btns.-type button');
    const $areaBtn = $con.find('.guide-vacantSearch__btns.-area button');

    const $posts = $con.find('.p-vacantPosts__posts');
    const $post = $con.find('.p-vacantPosts__post');

    if (!$typeBtns[0]) return true;

    init();

    function init() {
      let typeAll = [];

      $post.each(function (index, element) {
        const $t = $(this);

        let typeData = $t.attr('data-type').split(',');
        let areaData = $t.attr('data-area').split(',');

        $typeBtn.each(function (index, element) {
          const $t2 = $(this);

          $.each(typeData, function (index, val) {
            if (val == $t2.attr('data-value')) {
              $t2.parent('li').removeClass('is-hide');
            }
          });

        });

        $areaBtn.each(function (index, element) {
          const $t2 = $(this);

          $.each(areaData, function (index, val) {
            if (val == $t2.attr('data-value')) {
              $t2.parent('li').removeClass('is-hide');
            }
          });

        });
      });
    }

    $statusBtns.on('change', function () {
      search();
    });

    $allBtn.on('click', function () {
      const $t = $(this);

      $t.toggleClass('is-cr');

      if ($t.attr('data-value') == 'all') {
        $t.parent().parent().find('button').removeClass('is-cr');
      }

      search();
    });

    function search() {
      //すべてボタン
      if ($typeBtn.not('.-all').hasClass('is-cr')) {
        $typeBtn.filter('.-all').removeClass('is-cr');
      } else {
        $typeBtn.filter('.-all').addClass('is-cr');
      }

      if ($areaBtn.not('.-all').hasClass('is-cr')) {
        $areaBtn.filter('.-all').removeClass('is-cr');
      } else {
        $areaBtn.filter('.-all').addClass('is-cr');
      }

      //絞り込み
      $post.removeClass('is-show').hide();
      var count = 0;
      $post.each(function (index, element) {
        const $t = $(this);
        let hitCnt = 3;
        let val = '';

        val = $statusBtns.filter(':checked').val();
        const status = $t.attr('data-status');
        if (val == 'all') {
          hitCnt--;
        } else if (val == 'available' && (status == 'available')) {
          hitCnt--;
        } else if (val == 'negotiating' && (status == 'negotiating')) {
          hitCnt--;
        }

        $typeBtn.filter('.is-cr').each(function (index, element) {
          const $t2 = $(this);

          if ($t2.attr('data-value') == 'all') {
            hitCnt--;
            return false;
          } else {
            let typeData = $t.attr('data-type').split(',');

            $.each(typeData, function (index, val) {
              if (val == $t2.attr('data-value')) {
                hitCnt--;
                return false;
              }
            });
          }
        });

        $areaBtn.filter('.is-cr').each(function (index, element) {
          const $t2 = $(this);

          if ($t2.attr('data-value') == 'all') {
            hitCnt--;
            return false;
          } else {
            let areaData = $t.attr('data-area').split(',');

            $.each(areaData, function (index, val) {
              if (val == $t2.attr('data-value')) {
                hitCnt--;
                return false;
              }
            });
          }
        });

        if (hitCnt <= 0) {
          count++;
          if ($posts.hasClass('is-hide')) {
            if (count <= 9) {
              $t.fadeIn(400).addClass('is-show');
            } else {
              $t.removeAttr('style');
            }
          } else {
            $t.fadeIn(400).addClass('is-show');
          }
        }
      });
      if (count > 9) {
        if ($posts.hasClass('is-hide')) {
          $con.find('.guide-vacantMore').addClass('is-show');
        }
      } else {
        if ($posts.hasClass('is-hide')) {
          $con.find('.guide-vacantMore').removeClass('is-show');
        }
      }
    }
  });
});


/*以下single-vacant*/
$(function () {

  // スライドを初期化
  const slider = $('.vacant__images__slides');
  slider.slick({
    centerMode: true,
    variableWidth: true,
  });

  // スライドを移動させるとサムネイルも移動
  const thumbs = $('.vacant__images__thumb')
  slider.on('beforeChange', (_, __, ___, index) => {
    for (let thumb of thumbs) {
      thumb.classList.remove('is-current');
    }
    thumbs[index].classList.add('is-current');
  });

  // サムネイルをクリックしたらクリックしたスライドを表示
  const thumbAnchors = $('.vacant__images__thumb__anchor')
  for (let i = 0; i < thumbAnchors.length; i++) {
    let anchor = thumbAnchors[i];
    anchor.addEventListener('click', () => {
      slider.slick('slickGoTo', i);
    });
  }

  // スライド・間取りをクリックしたらモーダルで画像を表示
  const modal = $('.vacant__modal').remodal();
  const img = $('.vacant__modal__image img');
  const slides = $('.vacant__images__slides');
  slides.on('click', '.vacant__images__slide', e => {  // slickが要素を増やすため、第2引数のセレクタを使用する
    const slideImg = $(e.currentTarget).find('img');
    img.attr('src', slideImg.attr('src'));
    modal.open();
  });
  const anchors = $('.vacant__layout__image__anchor');
  anchors.on('click', e => {
    const layoutImg = $(e.currentTarget).find('img');
    img.attr('src', layoutImg.attr('src'));
    modal.open();
  })
  $(document).on('closed', '.vacant__modal', function (e) {
    img.attr('src', '');
  });
});

//FAQ
$(function () {
  $('.js-faq').each(function (index, el) {
    $(this).on('click', function (event) {
      $(this).toggleClass('on');
    });
  });
});
